import React from 'react';
import styles from '../styles/itembox.module.css'

const ItemBox = (props) => {
    return (
        <div className={styles.itemBox} onClick={props.clickHandler} data-item={props.dataItem}>
            {props.tagline ? (
                <div className={styles.descBox}>
                    <span>{props.skillName}</span>
                    <hr className={styles.descBoxDivider}/>
                    <span className={styles.tagline}>{props.tagline}</span>
                </div>
            ) : (
                <div className={styles.descBox}>
                    <span>{props.skillName}</span>
                </div>
            )}
        </div>
    );
  };
  
export default ItemBox;